import clsx from "clsx";

export type MessageBubbleVariant = "sent" | "received";

export interface MessageBubbleProps {
  text: string;
  variant: MessageBubbleVariant;
  testId?: string;
}

export function MessageBubble({ text, variant, testId = "message-bubble" }: MessageBubbleProps) {
  const isSent = variant === "sent";
  return (
    <div
      className={clsx(
        "max-w-[80%] px-4 py-2",
        isSent
          ? "self-end rounded-tl-2xl rounded-tr-2xl rounded-bl-2xl rounded-br-0 bg-lavender-500 text-white"
          : "self-start rounded-tl-2xl rounded-tr-2xl rounded-br-2xl rounded-bl-0 bg-gray-200 text-gray-900"
      )}
      data-testid={testId}
      data-own={isSent ? "true" : "false"}
    >
      {text}
    </div>
  );
}
